import { useQuery } from '@tanstack/react-query'
import { MessagesSquare } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import { useAuth } from '@/features/auth/useAuth'
import { summaryQuery } from '../api'
import { messagesBase } from '../format'

/** Top-bar shortcut to the messages, with the unread count (shares the polled summary). */
export function MessagesButton() {
  const { t } = useTranslation('messaging')
  const { status, can, portal } = useAuth()
  const enabled = status === 'authenticated' && can('messaging.use')
  const summary = useQuery(summaryQuery(enabled))
  if (!enabled) return null
  const count = summary.data?.unread ?? 0
  const label = count > 0 ? t('Messages, {{count}} unread', { count }) : t('Messages')

  return (
    <Link
      to={messagesBase(portal)}
      aria-label={label}
      title={label}
      className="relative grid size-10 place-items-center rounded-control text-ink-soft transition-colors hover:bg-surface-muted hover:text-ink"
    >
      <MessagesSquare className="size-5" aria-hidden="true" />
      {count > 0 ? (
        <span
          aria-hidden="true"
          className="pointer-events-none absolute top-0.5 right-0.5 grid h-4 min-w-4 place-items-center rounded-full bg-brand-600 px-1 text-[0.625rem] leading-none font-semibold text-white ring-2 ring-surface"
        >
          {count > 99 ? '99+' : count}
        </span>
      ) : null}
    </Link>
  )
}
